 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","pages-camera-camera-module":"pages-camera-camera-module","pages-company-company-details-company-details-module":"pages-company-company-details-company-details-module","pages-modals-image-modal-image-modal-module":"pages-modals-image-modal-image-modal-module","default~create-info-message-create-info-message-module~firebase-auth~pages-chat-addmembers-addmember~d9591021":"default~create-info-message-create-info-message-module~firebase-auth~pages-chat-addmembers-addmember~d9591021","default~create-info-message-create-info-message-module~friends-friends-module~pages-chat-group-group~447c9d64":"default~create-info-message-create-info-message-module~friends-friends-module~pages-chat-group-group~447c9d64","pages-chat-newgroup-newgroup-module":"pages-chat-newgroup-newgroup-module","pages-chat-groupinfo-groupinfo-module":"pages-chat-groupinfo-groupinfo-module","default~create-info-message-create-info-message-module~pages-chat-chat-tabs-chat-tabs-module~pages-c~be7435e5":"default~create-info-message-create-info-message-module~pages-chat-chat-tabs-chat-tabs-module~pages-c~be7435e5","default~chat-chat-tabs-chat-tabs-module~pages-chat-chat-tabs-chat-tabs-module":"default~chat-chat-tabs-chat-tabs-module~pages-chat-chat-tabs-chat-tabs-module","default~pages-company-edit-company-edit-company-module~pages-corporate-sharing-corporate-sharing-mod~f85f6a8e":"default~pages-company-edit-company-edit-company-module~pages-corporate-sharing-corporate-sharing-mod~f85f6a8e","pages-corporate-sharing-corporate-sharing-module":"pages-corporate-sharing-corporate-sharing-module","default~create-info-message-create-info-message-module~friends-friends-module~pages-chat-group-group~6eb10745":"default~create-info-message-create-info-message-module~friends-friends-module~pages-chat-group-group~6eb10745","pages-login-login-module":"pages-login-login-module","default~create-info-message-create-info-message-module~friends-friends-module~pages-chat-group-group~d5684d13":"default~create-info-message-create-info-message-module~friends-friends-module~pages-chat-group-group~d5684d13","pages-chat-group-group-module":"pages-chat-group-group-module","default~create-info-message-create-info-message-module~pages-clients-clients-module~pages-clients-gr~f6b26074":"default~create-info-message-create-info-message-module~pages-clients-clients-module~pages-clients-gr~f6b26074","pages-company-edit-company-edit-company-module":"pages-company-edit-company-edit-company-module","pages-clients-clients-module":"pages-clients-clients-module","default~create-info-message-create-info-message-module~pages-chat-message-message-module~pages-clien~071cfb24":"default~create-info-message-create-info-message-module~pages-chat-message-message-module~pages-clien~071cfb24","pages-user-edit-user-edit-module":"pages-user-edit-user-edit-module","pages-modals-static-modal-static-modal-module":"pages-modals-static-modal-static-modal-module","pages-register-register-module":"pages-register-register-module","pages-chat-message-message-module":"pages-chat-message-message-module","pages-estimates-create-create-module":"pages-estimates-create-create-module","pages-clients-group-group-module":"pages-clients-group-group-module","pages-clients-rank-rank-module":"pages-clients-rank-rank-module","pages-user-confirm-user-confirm-module":"pages-user-confirm-user-confirm-module","default~pages-settings-details-details-module~pages-settings-settings-module~tab5-tab5-module":"default~pages-settings-details-details-module~pages-settings-settings-module~tab5-tab5-module","pages-settings-settings-module":"pages-settings-settings-module","pages-user-share-user-info-share-user-info-module":"pages-user-share-user-info-share-user-info-module","pages-chat-userinfo-userinfo-module":"pages-chat-userinfo-userinfo-module","pages-forgot-password-forgot-password-module":"pages-forgot-password-forgot-password-module","pages-tabs-page-tabs-page-module":"pages-tabs-page-tabs-page-module","pages-thanks-thanks-module":"pages-thanks-thanks-module","pages-chat-addmembers-addmembers-module":"pages-chat-addmembers-addmembers-module","pages-chat-blockedlist-blockedlist-module":"pages-chat-blockedlist-blockedlist-module","pages-estimates-list-list-module":"pages-estimates-list-list-module","pages-tab4-detail-detail-module":"pages-tab4-detail-detail-module","pages-qr-code-scanner-qr-code-scanner-module":"pages-qr-code-scanner-qr-code-scanner-module","firebase-messaging":"firebase-messaging","pages-company-edit-company-settings-edit-company-settings-module":"pages-company-edit-company-settings-edit-company-settings-module","pages-company-share-details-share-details-module":"pages-company-share-details-share-details-module","pages-confirm-actions-confirm-actions-module":"pages-confirm-actions-confirm-actions-module","pages-error-page-pages-error-page-module":"pages-error-page-pages-error-page-module","pages-estimates-share-share-module":"pages-estimates-share-share-module","pages-estimates-status-list-status-list-module":"pages-estimates-status-list-status-list-module","pages-info-messages-info-messages-module":"pages-info-messages-info-messages-module","pages-maintenance-maintenance-module":"pages-maintenance-maintenance-module","pages-tab5-purchase-purchase-module":"pages-tab5-purchase-purchase-module","pages-tutorial-tutorial-module":"pages-tutorial-tutorial-module","polyfills-core-js":"polyfills-core-js","polyfills-css-shim":"polyfills-css-shim","polyfills-dom":"polyfills-dom","shadow-css-a3f00b33-js":"shadow-css-a3f00b33-js","swiper-bundle-6c5e7804-js":"swiper-bundle-6c5e7804-js","focus-visible-f4ad4f1a-js":"focus-visible-f4ad4f1a-js","input-shims-ce03ee9f-js":"input-shims-ce03ee9f-js","keyboard-5742b5da-js":"keyboard-5742b5da-js","status-tap-9cb487b1-js":"status-tap-9cb487b1-js","swipe-back-1bbd08e0-js":"swipe-back-1bbd08e0-js","tap-click-7ddcdebb-js":"tap-click-7ddcdebb-js","friends-friends-module":"friends-friends-module","groups-groups-module":"groups-groups-module","messages-messages-module":"messages-messages-module","tab4-tab4-module":"tab4-tab4-module","tab1-tab1-module":"tab1-tab1-module","tab5-tab5-module":"tab5-tab5-module","tab3-tab3-module":"tab3-tab3-module","create-info-message-create-info-message-module":"create-info-message-create-info-message-module"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
